import React from 'react';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';

import mtlogo from '../../assets/img/Metatheory-logo-white.png';
import dblogo from '../../assets/img/DB-logo-white.png';

import dbzip from '../../assets/media/DuskBreakers-logo-kit-v1.zip';
import mtzip from '../../assets/media/Metatheory-media-kit-v1.zip';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export default function Media() {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="media"
    >
      <Helmet>
        <title>Media - DuskBreakers</title>
        <meta
          name="description"
          content="Download artwork and other media related to DuskBreakers."
        />
      </Helmet>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="mb-5">Media</h1>
              <p className="pb-5">For press inquiries, contact metatheory[at]mprm[dot]com.</p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center g-4">
            <div className="col">
              <div className="media-container">
                <div className="row d-flex g-4">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header bg-secondary">DuskBreakers Logo Kit</div>
                      <div className="card-body d-flex flex-column justify-content-between">
                        <div>
                          <LazyLoadImage
                            className="img-fluid rounded"
                            alt="DuskBreakers Media Kit"
                            src={dblogo}
                            effect="opacity"
                          />
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="text-center">
                          <a href={dbzip} className="btn btn-sm btn-primary mb-2">
                            Download
                          </a>
                          <span className="d-block text-center text-small text-muted">
                            Filetype: zip
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-header bg-secondary">Metatheory Media Kit</div>
                      <div className="card-body d-flex flex-column justify-content-between">
                        <div>
                          <LazyLoadImage
                            className="img-fluid rounded"
                            alt="Metatheory Media Kit"
                            src={mtlogo}
                            effect="opacity"
                          />
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="text-center">
                          <a href={mtzip} className="btn btn-sm btn-primary mb-2">
                            Download
                          </a>
                          <span className="d-block text-center text-small text-muted">
                            Filetype: zip
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
